import { t } from '@lingui/macro';
import { i18n } from '@lingui/core';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Radio from '@material-ui/core/Radio';
import Icon from '@material-ui/core/Icon';
import classnames from 'classnames';
import React, { useState } from 'react';
import { connect } from 'react-redux';
import { onChangeMapFilters } from '../../../ac/onChangeMapFilters';
import { StandardRadioGroup } from '../StandardRadioGroup';
import { withDisplayedLayersCheck } from '../../../HOC/withDisplayedLayersCheck';
import { LegendRenderer } from '../../LegendRenderer/LegendRenderer';
import { ADMIN_AGG_TRACKS_V2_LEGEND } from '../../../constants/legends';
import * as V from '../../../constants/variables';
import styles from '../FilterSidebar.module.css';

const H3_ZOOMS = [ 6, 7, 8, 9, 10, 11, 12, 'auto' ];
// v2 не содержит tandem — только all/scooters/bikes
const VEHICLE_TYPES = [
    { value: 'all',      label: V.aggregatedTracksFilterValues[0].label },
    { value: 'scooters', label: V.aggregatedTracksFilterValues[1].label },
    { value: 'bikes',    label: V.aggregatedTracksFilterValues[3].label },
];
const PERIOD_TYPES = V.aggregatedTracksDayFilterValues;
const AdminAggTracksV2FilterComponent = ({
    onChangeMapFilters,
    adminAggTracksV2H3Zoom,
    adminAggTracksV2VehicleType,
    adminAggTracksV2Period,
}) => {
    const [ isH3ZoomExpanded, setIsH3ZoomExpanded ] = useState(false);
    const handleH3ZoomChange = ({ target: { value } }) => {
        onChangeMapFilters('adminAggTracksV2H3Zoom', value);
    };
    const handleVehicleTypeChange = ({ target: { value } }) => {
        onChangeMapFilters('adminAggTracksV2VehicleType', value);
    };
    const handlePeriodChange = ({ target: { value } }) => {
        onChangeMapFilters('adminAggTracksV2Period', value);
    };
    const toggleH3Zoom = () => {
        setIsH3ZoomExpanded(!isH3ZoomExpanded);
    };

    return (
        <div>
            <div className={styles.legHead}>{t`Агрегированные поездки`}:</div>
            <StandardRadioGroup
                value={adminAggTracksV2VehicleType}
                onChange={handleVehicleTypeChange}
            >
                {
                    VEHICLE_TYPES.map(({ value, label }) => (
                        <FormControlLabel
                            key={value}
                            className={styles.isochroneFilterLabel}
                            control={
                                <Radio
                                    checked={adminAggTracksV2VehicleType === value}
                                    onChange={handleVehicleTypeChange}
                                    value={value}
                                    className={classnames(
                                        styles.isochroneFilterInput, {
                                            [styles.checkedIsochroneFilterInput]: adminAggTracksV2VehicleType === value,
                                        }
                                    )}
                                    size="small"
                                />
                            }
                            label={i18n._(label)}
                            labelPlacement="end"
                        />
                    ))
                }
            </StandardRadioGroup>

            <div className={styles.legHead}>{t`Период`}:</div>
            <StandardRadioGroup
                value={adminAggTracksV2Period}
                onChange={handlePeriodChange}
            >
                {
                    PERIOD_TYPES.map(({ value, label }) => (
                        <FormControlLabel
                            key={value}
                            className={styles.isochroneFilterLabel}
                            control={
                                <Radio
                                    checked={adminAggTracksV2Period === value}
                                    onChange={handlePeriodChange}
                                    value={value}
                                    className={classnames(
                                        styles.isochroneFilterInput, {
                                            [styles.checkedIsochroneFilterInput]: adminAggTracksV2Period === value,
                                        }
                                    )}
                                    size="small"
                                />
                            }
                            label={i18n._(label)}
                            labelPlacement="end"
                        />
                    ))
                }
            </StandardRadioGroup>

            <div
                className={classnames(styles.legHead, {
                    [styles.expandableLegHead]: true,
                    [styles.expandableLegHeadOpen]: isH3ZoomExpanded,
                })}
                onClick={toggleH3Zoom}
                style={{ cursor: 'pointer', userSelect: 'none', display: 'inline-flex', alignItems: 'center' }}
            >
                {t`H3 Zoom`}:
                <Icon style={{ marginLeft: 'auto', transition: 'transform 0.25s ease' }}>expand_more</Icon>
            </div>
            {isH3ZoomExpanded && (
                <StandardRadioGroup
                    value={String(adminAggTracksV2H3Zoom)}
                    onChange={handleH3ZoomChange}
                >
                    {
                        H3_ZOOMS.map(zoom => (
                            <FormControlLabel
                                key={zoom}
                                className={styles.isochroneFilterLabel}
                                control={
                                    <Radio
                                        checked={String(adminAggTracksV2H3Zoom) === String(zoom)}
                                        onChange={handleH3ZoomChange}
                                        value={String(zoom)}
                                        className={classnames(
                                            styles.isochroneFilterInput, {
                                                [styles.checkedIsochroneFilterInput]: String(adminAggTracksV2H3Zoom) === String(zoom),
                                            }
                                        )}
                                        size="small"
                                    />
                                }
                                label={zoom}
                            />
                        ))
                    }
                </StandardRadioGroup>
            )}

            <LegendRenderer config={ADMIN_AGG_TRACKS_V2_LEGEND} />
        </div>
    );
};
const mapStateToProps = ({ mapFilters: { adminAggTracksV2H3Zoom, adminAggTracksV2VehicleType, adminAggTracksV2Period } }) => ({
    adminAggTracksV2H3Zoom,
    adminAggTracksV2VehicleType,
    adminAggTracksV2Period,
});
const ConnectedComponent = connect(mapStateToProps, { onChangeMapFilters })(AdminAggTracksV2FilterComponent);

export const AdminAggTracksV2Filter = withDisplayedLayersCheck(
    ConnectedComponent,
    t`Агрегированные треки за последние 7 дней`
);
